import * as React from "react";
import {Field} from "react-final-form";
import {TiposGestion as tiposGestion} from "../modelo/TiposGestion";

export default class TiposGestion extends React.Component<TiposGestionProps> {
    render() {
        const {className} = this.props;
        return (
            <Field name={this.props.name}>
                {({input, meta}) => (
                    <div>
                        <select {...input} className={className ? className.concat(" form-control") : "form-control"}>
                            <option value={""}>Selecciona...</option>
                            {tiposGestion.map(gestion => {
                                return <option key={gestion} value={gestion}>{gestion}</option>;
                            })}
                        </select>
                        <div>
                            {meta.error && <span className={"text-danger"}>{meta.error}</span>}
                        </div>
                    </div>
                )}
            </Field>
        );
    }
}

interface TiposGestionProps {
    name: string,
    className?: string
}


// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/inconsistencias/componentes/TiposGestion.tsx